// extracted by mini-css-extract-plugin
module.exports = {"timeSign":"style_timeSign__1i-VA"};